module.exports = __webpack_public_path__ + "img/组 127@2x(3).9e558c61.png";